import * as React from "react";
import {useEffect} from "react";
import {RouteComponentProps, Redirect} from "react-router-dom";
import ShubhForm from "shubhform";
import {connect} from "react-redux";
import {IReduxState} from "reducers";
import {getAddressFields, insideHeader, removeCountryCode} from "egold/utils";
import {profileStyle} from "egold/utils";
import {IEgoldUserDetails, IGoldProductDetails, IPincodeDetails} from "StateInterface";
import {handleNavigation, indexPath, routePaths} from "egold/routes";
import {redeemGold} from "egold/actions";
import {vendor} from "egold/egold-config";
import {imageBaseUrl} from "config";

interface IConnectProps {
    dispatch?: (action: any) => void;
    productIndex: number;
    products: IGoldProductDetails[];
    pincodeDetails: IPincodeDetails;
    eGoldUserDetails: IEgoldUserDetails;
}

function UserDetails(props: IConnectProps & RouteComponentProps) {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    function handleSubmit(currentValues) {
        const addressField = {};
        let name = "";
        currentValues.forEach((field) => {
            if (field.name === "name") {
                name = field.value;
            } else {
                addressField[field.name] = field.value;
            }
        });
        const userInfo = {
            vendor_id: props.eGoldUserDetails.vendor_id,
            product_code: Number(props.products[props.productIndex].id),
            name,
            phone_no: removeCountryCode(String(props.eGoldUserDetails.mobile)),
            address: addressField,
        };
        props.dispatch(redeemGold(vendor.SAFEGOLD, props.eGoldUserDetails.user_id, userInfo));
        handleNavigation(routePaths.CONFIRM_DELIVERY);
    }
    if (props.productIndex === null || props.productIndex === undefined) {
        return <Redirect to={`${indexPath}${routePaths.DELIVERY}`}/>;
    }
    return(
            <div className="delivery-address-container">
                {insideHeader("Gold Delivery", props.history.goBack)}
                <div className="my-3 mx-2">
                    <h3 className={"egold-title-text"}>{props.products[props.productIndex].description}</h3>
                    <h6 className={"egold-sub-text"}>
                       Making Charges Rs.{props.products[props.productIndex].making_charges}
                    </h6>
                    <small className="m-0">
                        Powered by: <img className="my-2" src={`${imageBaseUrl}/img/icons/eGold/safegold_logo.svg`} style={{width: "100px"}}/>
                    </small>
                    <h6 className="mt-4"><b>Enter Address</b></h6>
                    <p className="details-text">
                        Please share the address to which you would like the product to be delivered.
                    </p>
                </div>
                <ShubhForm
                    fields={getAddressFields(props.pincodeDetails)}
                    onSubmit={handleSubmit}
                    onValidate={handleValidation}
                    customStyles={profileStyle()}
                    submitTitle="Confirm"
                />
            </div>
    );
}

function handleValidation(currentValues) {
    let validation = {status: true, errors: null};
    for (const i of currentValues) {
        i.value = String(i.value).trim();
        if (i.value === "") {
            validation = {status: false, errors: {[i.name]: "Field is required"}};
            break;
        }
    }
    return validation;
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        productIndex: state.eGold.selectedProductIndex,
        products: state.eGold.products,
        pincodeDetails: state.eGold.pincodeDetails,
        eGoldUserDetails: state.eGold.eGoldUserDetails,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(UserDetails);
